module.exports = __webpack_public_path__ + "static/fa-23d8cf3ceb495ecda9edabf54cbddb97.jpg";